// Loader.js (Loader component)
import React from 'react';
import './Loader.css'; // Import your CSS file for styling

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading...</div>
      </div>
    </div>
  );
};

export default Loader;
